import React, { useRef, useEffect, useState } from 'react';
import AppPromo from '../restaurent/appPromo/AppPromo';
import { apiData } from '../../../actions';
import moment from "moment";
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import new2 from "../../../images/slide2.webp";
import Footer from '../../footer/Footer';
import ContactModal from '../../Modals/ContactModal';
import Header from '../../header/Header';
import AdrenalineRush from '../thingsToDo/adrenalineRush/AdrenalineRush';
import LoginModal from '../../Modals/LoginModal';
const SingleBlog = () => {
	const routePath = useLocation();
	const [blog, setBlog] = useState([]);
	const [place, setPlace] = useState("");
	const modalBodyRef = useRef(null);
	const [contactModal, SetContactModal] = useState(false);
	const [seeMoreModal, setSeeMoreModal] = useState(false);
	const [dealsData, setDealsData] = useState([]);
	const [fullContentUrl, setFullContentUrl] = useState("");
	const Blog_details = async () => {
		const payload = { slug: routePath.pathname.split("/")[2] };
		const apiRes = await apiData.single_Blog(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setBlog(apiRes?.data?.data);
			const city = apiRes?.data?.data[0].city.split(",")[0];
			setPlace(city);
			const payload1 = { city };
			const apiRes1 = await apiData.inclusiveDeals(payload1);
			if (apiRes1?.status >= 200 && apiRes1?.status <= 399) {
				document.getElementById("InclusiveScript").innerHTML = "";
				const script1 = document.createElement('script');
				script1.src = apiRes1?.data?.data?.getYourGuide[0]?.content?.split('"')[1].replace(/(?<=items=)\d+/, "4");
				document.getElementById("InclusiveScript").appendChild(script1);
				setFullContentUrl(apiRes1?.data?.data?.getYourGuide[0]?.content?.split('"')[1].replace(/(?<=items=)\d+/, "20"));
			}
			let payload2 = { city, keyword: "Hotels", limit: 4 };

			let apiRes2 = await apiData.getRandomDeals(payload2);
			if (apiRes2?.status >= 200 && apiRes2?.status <= 399) {
				const hotelContent = apiRes2?.data?.data[0]?.content;
				if (hotelContent && hotelContent.includes('"')) {
					let script = document.createElement('script');
					script.id = "stay";
					script.src = hotelContent.split('"')[1];
					document.getElementById("hotel_stay").appendChild(script);
				} else {
					const hotelStayDiv = document.getElementById("hotel_stay");
					if (hotelStayDiv) {
						const warningDiv = document.createElement('div');
						warningDiv.style.color = '#b2b2b2';
						warningDiv.style.padding = '10px';
						warningDiv.style.textAlign= 'center';
						warningDiv.textContent = "Hotels not available or malformed.";
						hotelStayDiv.appendChild(warningDiv);
					}
				}
			}
			if (apiRes2?.status >= 400 && apiRes2?.status <= 500) {
				console.log("error");
			}
			let payload3 = {
				city: apiRes?.data?.data[0].city.split(",")[0],
				keyword: "Flights",
				limit: 4
			};
			let apiRes3 = await apiData.getRandomDeals(payload3);
			if (apiRes3?.status >= 200 && apiRes3?.status <= 399) {
				setDealsData(
					apiRes3?.data?.data
				);
			}
			if (apiRes3?.status >= 400 && apiRes3?.status <= 500) {
				console.log("error");
			}
		}
	}

	const handleSeeAllClick = async () => {
		setSeeMoreModal(true);

	}
	useEffect(() => {
		if (seeMoreModal && modalBodyRef.current) {
			// Clear previous content
			modalBodyRef.current.innerHTML = '';
			// Create and append script
			let script2 = document.createElement('script');
			script2.src = fullContentUrl.replace(/(?<=items=)\d+/, "20");
			modalBodyRef.current.appendChild(script2);
		}
	}, [seeMoreModal, fullContentUrl]);

	useEffect(() => {
		Blog_details();
		window.scroll({ top: 0, behavior: "instant" });
	}, []);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [prevCity, setPrevCity] = useState("");
	
	useEffect(() => {
		const visitedCities = JSON.parse(localStorage.getItem("visitedCities")) || [];
		const hasSeenBlogPopup = localStorage.getItem("hasSeenBlogPopup");
		if (!hasSeenBlogPopup) {
			setIsModalOpen(true);
			localStorage.setItem("hasSeenBlogPopup", "true");
		} else if (!visitedCities.includes(place)) {
			setIsModalOpen(true);
			localStorage.setItem("visitedCities", JSON.stringify([...visitedCities, place]));
		} else {
			console.log(`Popup will not open. City "${place}" is already visited.`);
		}

		if (place !== prevCity) {
			setPrevCity(place);
		}
	}, [place, prevCity]);

	const handleClose = () => {
		setIsModalOpen(false);
	};
	// Removed unused formData and related handlers


	return (
		<>
			<Helmet>
				<title>{blog && blog[0]?.seo_title}</title>
				<meta
					name="keyword"
					content={blog && blog[0]?.seo_keyword}
				/>
				<meta
					name="description"
					content={blog && blog[0]?.seo_description}
				/>
			</Helmet>
			<Header />
			<div className="banner-section rest-sec">
				<div className="container">
					<div className="row">
						<div className="col-12 col-sm-12 col-md-12 col-lg-12">
							<div className="blogs">
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="comedy-sec">
				<div className="container">
					<div className="row">
						<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
						</div>
					</div>
				</div>
			</div>
			<div className="blog-details-wrapper pt-5 rind-the-right-section">
				<div className="container">
					<div className="row">
						<div className="col-lg-9">
							<div className="blog-details">
								<div className="blog-title-xl">
									<h3>{blog && blog[0]?.title}</h3>
									<div className="blog-info-xl">
										<a href="" className="blog-writer">
											<img  src="/images/Calendar.svg" alt='' />
											{moment(blog && blog[0]?.date).format(
												"MMMM Do YYYY"
											)}
										</a>
										<a className="blog-comment" href="#/" >
											<img src="/images/location.svg" alt='Images' />
											{blog && blog[0]?.city}</a>
									</div>
								</div>
								<div className="blog-img-xl">
									<img loading="lazy" src={blog && blog[0]?.image} alt="" className="img-fluid" />
								</div>
								<div dangerouslySetInnerHTML={{ __html: blog && blog[0]?.post_content.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"') }} className="blog-texts mt-3">
								</div>
							</div>
						</div>
						<div className="col-lg-3">
							<div className="blog-sidebar">
								<div className="row">
									<div className="col-lg-12 col-md-6">
										<h5 className="text-center font-weight-light">Hotels in {blog && blog[0]?.city}</h5>

										<div id="hotel_stay" className="d-flex flex-wrap overflow-auto" style={{ height: '600px' }}>

										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12 col-md-6">
										<div className="blog-tag mt-40">
											<h5 className="text-center font-weight-light">Flights in {blog && blog[0]?.city}</h5>
											<div>
												<div className="deal-flight">
													<div className="container">
														<div class="row" className="d-flex flex-wrap overflow-auto" style={{ height: '600px' }}>
															<div id="deal-flight" className="d-flex flex-wrap overflow-auto" style={{ height: '600px' }}>
																{dealsData && dealsData.length > 0 ? (
																	dealsData.map((ele) => (
																		<div className='deal-fligh-divs' key={ele?.id}>
																			<div className="slider-block">
																				<a href={ele?.link} target="_blank" rel="noreferrer">
																					<img loading="lazy" src={`${ele?.image}`} alt='Flight-deals' />
																					<h6>{ele?.city_name} <i className="fa fa-plane flight_deal_icon" aria-hidden="true"></i> {blog && blog[0]?.city}</h6>
																				</a>
																			</div>
																		</div>
																	))
																) : (
																	<div style={{color: '#b2b2b2', padding: '10px', textAlign: 'center', width: '100%'}}>Flights not available or malformed.</div>
																)}
																{/* The script or warning will be injected here by JS if needed */}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-lg-12'>
							<div id="InclusiveScript">

							</div>
							{fullContentUrl && fullContentUrl.length > 0 && (
								<div className='view-tag'>
									<a className='clickable' onClick={handleSeeAllClick}>see all</a>
								</div>
							)}
						</div>
					</div>
					<AdrenalineRush />
				</div>
			</div>
			<>
				<Modal
					show={seeMoreModal}
					onHide={() => setSeeMoreModal(false)}
					size="xl"
					className='modal_xl see-pop'
					keyboard={false}
				>
					<Modal.Header closeButton>
						<Modal.Title>All Tours</Modal.Title>
					</Modal.Header>
					<Modal.Body ref={modalBodyRef}>
					</Modal.Body>
				</Modal>
			</>
			<>
				{/* Script single blog popup Modal */}
				{/* <Modal className="model_width_form formslide" show={isModalOpen} onHide={handleClose} centered>
					<Modal.Header closeButton>
					</Modal.Header>
					<Modal.Body className="slider-modal-dialog">
						<div className="modal-body slide-form-body">
							<div className="row">
								<div className="col-md-6 col-12">
									<div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
										<div className="carousel-indicators">
											<button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to={1} aria-label="Slide 2"></button>
										</div>
										<div className="carousel-inner slider-form">

											<div className="carousel-item active" data-bs-interval={10000}>
												<img loading="lazy" src={new2} className="d-block w-100" alt="Slide 2" />
												<div className="sliderItembackdrop"></div>
												<div className="carousel-caption d-md-block">

													<h5>Plan Your {place ? place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase()) : ''} Trip with MySittiVacations&mdash;Insider Tips Included!</h5>

												</div>
											</div>

										</div>
									</div>
								</div>
								<div className="col-md-6 col-12">
									<div className="slide_form_sec">
										<h4>Grab Your Free {place ? place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase()) : ''} e-Book: Adventure Guide!</h4>
										<form onSubmit={handleSubmit}>
											<div className="input-sec">
												<label htmlFor="exampleFormControlInput2" className="form-label">Name</label>
												<input
													type="text"
													className={`form-control ${errors.name ? 'is-invalid' : ''}`}
													id="exampleFormControlInput2"
													placeholder="First Name"
													value={name}
													onChange={handleNameChange}
												/>
												{errors.name && <div className="invalid-feedback">{errors.name}</div>}
											</div>
											<div className="input-sec">
												<label htmlFor="email" className="form-label">Email</label>
												<input
													type="text"
													className={`form-control ${errors.email ? 'is-invalid' : ''}`}
													id="email"
													placeholder="Email Address"
													value={email}
													onChange={handleEmailChange}
												/>
												{errors.email && <div className="invalid-feedback">{errors.email}</div>}
											</div>
											<div className="input-sec">
												<label htmlFor="travelerType" className="form-label">Traveler Type</label>
												<select
													className={`form-control ${errors.travelerType ? 'is-invalid' : ''}`}
													id="travelerType"
													name="travelerType"
													value={travelerType}
													onChange={handleTravelerTypeChange}
												>
													<option value="">Select Type</option>
													<option value="LGBTQ">LGBTQ</option>
													<option value="Solo Female">Solo Female</option>
													<option value="General">General</option>
													<option value="Family">Family</option>
													<option value="Couple">Couple</option>
												</select>
												{errors.travelerType && <div className="invalid-feedback">{errors.travelerType}</div>}
											</div>

											<button type="submit" className="btn btn-primary w-100">Start Planning</button>
										</form>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
				</Modal> */}
				{isModalOpen && <LoginModal loginModal={isModalOpen} setLoginModal={setIsModalOpen} />}
			</>
			<AppPromo />
			<Footer />
			{contactModal && <ContactModal contactModal={contactModal} SetContactModal={SetContactModal} />}
		</>
	)
}
export default SingleBlog